import { css } from '@emotion/core';

export const styWrapper = css`
  .sub-title {
    color: #828282;
    font-weight: 600;
    letter-spacing: 1px;
    line-height: 20px;
  }

  p {
    font-size: 16px;
    margin-top: 16px;
  }

  @media screen and (max-width: 500px) {
    .sub-title {
      font-size: 18px;
      margin: 0 0 8px 0;
    }

    p {
      font-size: 16px;
    }
  }

  @media screen and (max-width: 400px) {
    p {
      font-size: 14px;
    }
  }
`;

export const revealAnimation = css`
  opacity: 0;
  transform: translateY(20px);
  transition: all 0.6s ease-out;
  transition-delay: 0.2s;

  &.reveal {
    opacity: 1;
    transform: translateY(0);
  }

  h2, h3, p {
    opacity: 0;
    transform: translateY(20px);
    transition: all 0.6s ease-out;

    &.reveal {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;
